module.exports = __webpack_public_path__ + "img/17_82.2b801299.png";